import { useQuery } from '@tanstack/react-query'

import { getQuickSearch } from '../utils/search-service'
import { notifySentry } from '../utils/sentry'

export const useSurname = (surname, friendSurname) => {
  surname = surname?.toLowerCase?.()
  friendSurname = friendSurname?.toLowerCase?.()
  return useQuery({
    queryKey: ['surname-search', surname, friendSurname],
    queryFn: async () => {
      try {
        const resp = await getQuickSearch({
          type: 'surname',
          query: friendSurname ? { 'q.surname': surname, 'q.friendSurname': friendSurname } : { 'q.surname': surname },
        })
        if (resp?.data?.surnameStatus !== 'SUCCESS') throw new Error('Surname failed')
        const surnameDetails = resp?.data?.results?.[0]
        const countries = Array.isArray(surnameDetails?.countries) ? surnameDetails.countries.slice(0, 3) : []
        return {
          count: resp?.data?.surnamesTotal,
          surname: surnameDetails?.surname,
          countries,
          htmlDefinition: surnameDetails?.htmlDefinition,
          attribution: surnameDetails?.attribution,
          attributionURL: surnameDetails?.attributionURL,
          variants: Array.isArray(surnameDetails?.variants?.VARIANT) ? surnameDetails?.variants?.VARIANT : [],
          friendSurname: surnameDetails?.friendSurname,
        }
      } catch (error) {
        notifySentry({
          message: 'Failed to fetch surname details',
          error,
          extraData: { surname, friendSurname },
        })
        throw error
      }
    },
    enabled: Boolean(surname?.length),
    retry: 3,
  })
}
